import { isTokenExpired } from '../auth/authUtils';
import { refreshToken } from '../auth/tokenUtils';

export const fetchWithToken = async (url: string, options: RequestInit = {}) => {
  let token = localStorage.getItem('token');

  if (!token || isTokenExpired(token)) {
    token = await refreshToken();
    if (!token) {
      throw new Error('Unable to refresh token, please log in again.');
    }
  }

  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
    'Authorization': `Bearer ${token}`,
  };

  return fetch(url, { ...options, headers });
};

